import { useContext } from 'react';

import { ClusterDbSocketContext } from './ClusterDbSocketProvider';

export function useClusterDbSocketContext() {
  const context = useContext(ClusterDbSocketContext);
  if (!context) {
    throw new Error(
      'useClusterDbSocketContext must be used within a ClusterDbSocketProvider'
    );
  }
  return context;
}
